import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import LazyLoad from 'react-lazyload';

// STYLES
import { ReasonItemContainer } from './styles';

const ReasonItem = ({ src, title, text }) => {
  return (
    <ReasonItemContainer className="service-item">
      <LazyLoad height={40} once>
        <img src={src} alt={title} />
      </LazyLoad>
      <Typography variant="h5">{title}</Typography>
      <p className="p4">{text}</p>
    </ReasonItemContainer>
  );
};

ReasonItem.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default React.memo(ReasonItem);
